import { render } from "./TodoComponent.vue?vue&type=template&id=48099fc4&scoped=true"
import script from "./TodoComponent.vue?vue&type=script&lang=js"
export * from "./TodoComponent.vue?vue&type=script&lang=js"

import "./TodoComponent.vue?vue&type=style&index=0&id=48099fc4&scoped=true&lang=css"

import exportComponent from "D:\\Pranav\\Coding\\MyProjects\\Own Projects\\todo_list_vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48099fc4"]])

export default __exports__